import { FC } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations'

import { BUSINESS_PRIORITIES_TRANSLATION_KEYS as KEYS } from '../../configs/translations'
import { selectEditingPriority } from '../../model/selectors'
import { BusinessPrioritiesHeader } from '../businessPrioritiesHeader'

interface IBusinessPrioritiesEditHeaderProps {
  isWorldwide: boolean
  market?: string
  className?: string
}

export const BusinessPrioritiesEditHeader: FC<IBusinessPrioritiesEditHeaderProps> = ({
  className,
}) => {
  const editingPriority = useSelector(selectEditingPriority)
  const isEdit = Boolean(editingPriority)

  return (
    <BusinessPrioritiesHeader
      title={<Translation text={isEdit ? KEYS.form.editTitle : KEYS.form.createTitle} />}
      className={className}
    />
  )
}

BusinessPrioritiesEditHeader.displayName = 'BusinessPrioritiesEditHeader'

export default BusinessPrioritiesEditHeader
